import React, { useState, useEffect } from 'react';

const CountdownItem = ({ countdown }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = new Date(countdown.end_date) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    } else {
        return null; // Expired
    }
    return timeLeft;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const tl = calculateTimeLeft();
      if (!tl) {
          clearInterval(timer);
      }
      setTimeLeft(tl);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown.end_date]);

  if (!timeLeft) return null;

  const formatNumber = (num) => num.toString().padStart(2, '0');

  return (
    <div className="flex flex-col justify-center items-center space-y-4 w-full">
        {countdown.title && (
          <h2 className="text-lg md:text-2xl font-bold text-white font-josefin mb-4 text-center px-4">
            {countdown.title}
          </h2>
        )}
        <div className="grid grid-cols-2 sm:grid-cols-4 justify-center gap-3 sm:gap-4 md:gap-6 lg:gap-8 w-full max-w-4xl mx-auto px-4">
          {/* Days */}
          <div className="flex flex-col items-center bg-white/20 rounded-lg px-3 py-2 sm:px-4 sm:py-3 min-w-[70px] sm:min-w-[80px] md:min-w-[90px]">
            <div className="text-xl sm:text-2xl  font-bold text-white font-josefin">
              {formatNumber(timeLeft.days)}
            </div>
            <div className="text-[10px] text-white uppercase tracking-wide font-josefin mt-1">
              Days
            </div>
          </div>
          
          {/* Hours */}
          <div className="flex flex-col items-center bg-white/20 rounded-lg px-3 py-2 sm:px-4 sm:py-3 min-w-[70px] sm:min-w-[80px] md:min-w-[90px]">
            <div className="text-xl sm:text-2xl  font-bold text-white font-josefin">
              {formatNumber(timeLeft.hours)}
            </div>
            <div className="text-[10px] text-white uppercase tracking-wide font-josefin mt-1">
              Hours
            </div>
          </div>
          
          {/* Minutes */}
          <div className="flex flex-col items-center bg-white/20 rounded-lg px-3 py-2 sm:px-4 sm:py-3 min-w-[70px] sm:min-w-[80px] md:min-w-[90px]">
            <div className="text-xl sm:text-2xl  font-bold text-white font-josefin">
              {formatNumber(timeLeft.minutes)}
            </div>
            <div className="text-[10px] text-white uppercase tracking-wide font-josefin mt-1">
              Minutes
            </div>
          </div>
          
          {/* Seconds */}
          <div className="flex flex-col items-center bg-white/20 rounded-lg px-3 py-2 sm:px-4 sm:py-3 min-w-[70px] sm:min-w-[80px] md:min-w-[90px]">
            <div className="text-xl sm:text-2xl  font-bold text-white font-josefin">
              {formatNumber(timeLeft.seconds)}
            </div>
            <div className="text-[10px] text-white uppercase tracking-wide font-josefin mt-1">
              Seconds
            </div>
          </div>
        </div>
    </div>
  );
};

export default CountdownItem;